import { IEnumOption } from 'modules/shared/interfaces/enumOptions';

export enum ResponseType {
	ONE_SELECTION,
	MULTIPLE_SELECTION,
	ONE_SELECTION_WITH_DESC,
}

export const responseTypeEnumOptions: IEnumOption[] = [
	{
		value: ResponseType.ONE_SELECTION,
		label: 'One selection',
	},
	{
		value: ResponseType.MULTIPLE_SELECTION,
		label: 'Multiple selections',
	},
	{
		value: ResponseType.ONE_SELECTION_WITH_DESC,
		label: 'One selection with description',
	},
];
